<template>
    <div class="report" v-if="reportStatue">
        <div class="report-top">
            <div class="name">举报</div>
            <div @click="guanbi" class="guanbiCss">
                <img src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="">
            </div>
        </div>
        <div class="report-center1">
            <span class="alert">*</span>
            <span class="descript">举报描述</span>
        </div>
        <div class="report-center2">
            <textarea v-model="content" style="word-break:break-all" cols="30" rows="10" placeholder="请详细描述具体违规情节以及发生的地点"></textarea>
        </div>
         <div class="report-center1">
            <span class="alert">*</span>
            <span class="descript">上传图片</span>
        </div>
        <div class="report-center4">
            <el-upload
              class="avatar-uploader"
              action=""
              :show-file-list="false"
              :on-success="handleAvatarSuccesss"
              :before-upload="beforeAvatarUploadd"
              :http-request="aa"
              name="avatar"
              multiple
              >
              <div v-if="imageUrl1" style="position: relative;width: 88px;height: 88px;">
                  <img :src="imageUrl1" class="avatar">
                  <div style="text-align: center;line-height: 33px;color:#ffffff;width: 88px;height: 33px;position: absolute;bottom:0;border-radius: 0px 0px 6px 6px;background: rgba(0, 0, 0, 0.5);">重新上传 +</div>
              </div>
              <div v-else class="avatar-uploader-icon">
                  <i class="el-icon-plus" style="margin-top:20px;font-size:50px;"></i>
              </div>
            </el-upload>
        </div>
         <div class="report-center1">
            <span class="alert">*</span>
            <span class="descript">联系方式</span>
        </div>
        <div class="report-center2">
            <input v-model="concactInfo" type="text" class="bottom-input" placeholder="请留下您的联系方式，方便回访">
        </div>
        <div class="report-center2" style="margin-top:20px;">
            <div @click="Jubao" class="btn btnhover">提交举报</div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import qs from 'qs'
export default {
    data() {
        return {
            imageUrl1:"",
            content:"",//举报描述
            concactInfo:"",//联系方式
            reportTupian:"",// 举报图片
            useruid:"",//举报用户Uid
            reportStatue:false,
        }
    },
    methods: {
      setUids(newVal){
        console.log('设置uid',newVal);
        this.reportStatue = true;
        this.useruid = newVal;
      },
        // 提交举报
        Jubao(){
            this.$axios({
                headers: {
                  "device": "web",
                  "packageId": "1",
                  "version": "1.0.0",
                  "channel":"web",
                  "authToken":localStorage.getItem('token'),
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
                  data = qs.stringify(data)
                  return data
                }],
                url:this.api+'/v1/report/informe',
                method:'post',
                data:{
                    uid:this.useruid,
                    content:this.content,
                    imgUrl:this.reportTupian,
                    concactInfo:this.concactInfo
                }
            }).then(res =>{
                this.$emit("jubao",false);
                 this.$message({
                    message: "举报成功",
                    type: "success",
                });
                console.log(res);
            })
        },
        guanbi(){
            this.$emit("jubao",false)
            this.reportStatue = false
        },
        aa(e){
            var file = e.file
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                let fileResult = "";
                reader.readAsDataURL(file);
                //开始转
                reader.onload = function() {
                  fileResult = reader.result;
                };
                //转 失败
                reader.onerror = function(error) {
                  reject(error);
                };
                //转 结束  咱就 resolve 出去
                reader.onloadend = function() {
                  resolve(fileResult);
                };
            });
        },
        handleAvatarSuccesss(res, file) {
            this.imageUrl1 = URL.createObjectURL(file.raw);
            this.reportTupian = res;
        },
        
        beforeAvatarUploadd(file) {
        this.file = file;
          const isJPG = file.type === 'image/png';
          const isJPG2 = file.type === 'image/jpeg';
          const isLt2M = file.size / 1024 / 1024 < 2
          if (!isJPG&&!isJPG2) {
            this.$message.error('上传图片只能是JPG或者png格式!');
          }
          if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
          }
          return isJPG2 || isJPG && isLt2M;
        },
    },
}
</script>

<style scoped lang='scss'>
.guanbiCss{
    height: 22px;
}
.guanbiCss:hover{
    transform: rotate(180deg);
    cursor:pointer;
    transition: transform .5s ease;
}
.report{
    width: 360px;
    height: 535px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-60%,-50%);
    z-index: 100;
}
.report-top{
    width: 360px;
    height: 54px;
    box-sizing: border-box;
    padding: 0 15px 0 15px;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }
}
.report-center1{
     width: 360px;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    padding: 0 15px 0 15px;


    .descript{
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;

    font-weight: 400;
    }
    .alert{
font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ED1010;
    }
}
.report-center2{
    box-sizing: border-box;
    padding: 0 15px 0 15px;
     width: 360px;
     display: flex;
     justify-content: center;

}
.report-center2>textarea{
    width: 100%;
    min-height: 120px;
    max-height: 120px;
    border-radius: 6px;
    background-color: #DADADA;
    line-height: 20px;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px;
    border: none;
    outline:none;
}
.report-center3{
    width: 418px;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    padding: 0 15px 0 15px;
}
.report-center4{
    width: 418px;
    line-height: 45px;
    box-sizing: border-box;
    padding: 0 15px 0 15px;
}
.bottom-input{
    height: 38px;
    border-radius: 4px;
    background-color: #DADADA;
    width: 329px;
    box-sizing: border-box;
    padding-left:15px;
    border: none;
    outline:none;
    font-size: 14px;
}
.btnhover{
    width: 178px;
height: 42px;
text-align: center;
cursor: pointer;
line-height: 42px;
color: #fff !important;
background: rgba(114, 30, 220, 1);
border-radius: 21px;
}
.avatar-uploader-icon {
  /* font-size: 16px; */
  color: #8c939d;
  width: 88px !important;
  height: 88px !important;
  /* line-height: 178px; */
  text-align: center;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .avatar{
    width: 88px;
    height: 88px;
    background-size: 100% 100%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/component/Report.vue